import { Pipe, PipeTransform } from '@angular/core';
import { CacheMap } from '../classes';

@Pipe({ name: 'cacheValues' })
export class CacheValuesPipe implements PipeTransform {
  transform<T>(cache: CacheMap<T>, ...args: string[]) {
    if (!cache) return null;
    const [keepId] = args;
    return [...cache.with(keepId).values()];
  }
}
